import Chip from '@mui/material/Chip'
import Label from 'app/shared-components/Label'

import useStyles from './ListView.styles'

export default function ListView({
    value = [],
    title,
}: Readonly<{
    value: string[],
    title?: string,
}>) {
    const {
        classes,
    } = useStyles()

    return (
        <>
            {title ? (
                <Label
                    title={title}
                />
            ) : null}
            <div className={classes.wrapper}>
                {value?.length ? value?.map((item, index) => {
                    return (
                        <Chip
                            className={classes.chip}
                            key={`${item}-item-${index}`} /* eslint-disable-line react/no-array-index-key */
                            label={item}
                            sx={{
                                height: 22,
                                fontSize: 12,
                            }}
                        />
                    )
                }) : '-'}
            </div>
        </>
    )
}
